import { create } from "zustand";
import api from "@/lib/api";

export const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  isCheckingAuth: false,
  code: null,
  phone: null,
  action: null,

  setCode: (code) => set({ code }),
  setPhone: (phone) => set({ phone }),
  setAction: (action) => set({ action }),

  logout: async () => {
    const token =
      typeof window !== "undefined"
        ? localStorage.getItem("auth_token")
        : null;

    set({
      user: null,
      isAuthenticated: false,
      isCheckingAuth: false,
      code: null,
      phone: null,
      action: null,
    });

    if (typeof window !== "undefined") {
      localStorage.removeItem("auth_token");
    }

    try {
      if (token) {
        await api("/api/v1/auth/logout", {
          method: "POST",
          credentials: "omit",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    } catch (error) {
      console.error("Logout failed:", error);
    }
  },


  login: (user, token) => {
    if (typeof window !== "undefined") {
      localStorage.setItem("auth_token", token);
    }
    set({ user: user, isAuthenticated: true });
  },

  checkAuth: async () => {
    try {
      set({ isCheckingAuth: true });
      const response = await api("/api/v1/user", { method: "GET" });
      set({ user: response, isAuthenticated: true, isCheckingAuth: false, });
      return response;
    } catch (error) {
      set({ user: null, isAuthenticated: false, isCheckingAuth: false });
      return null;
    }
  },
}));
